import { URLS, getAPIEndPoint } from "../consts/APIEndpoints";
import { REPORT_INTERVALS } from "../consts/Campaign";
import { getResponse } from "../utils/common";
import { determineBucketSize } from "../utils/reports";

export async function getFolderAPI(folder_id, params = {}) {
    let response = await getResponse(
      `${getAPIEndPoint(URLS.FOLDERS_API)}/${folder_id}`,
      "get",
      undefined,
      {
        ...params,
      }
    );
    return response;
}

export async function updateFolderAPI(folderObj, folder_id, params) {
    let response = await getResponse(
      `${getAPIEndPoint(URLS.FOLDERS_API)}/${folder_id}`,
      "put",
      folderObj,
      {
        ...params,
      }
    );
    return response;
}

export async function createFolderAPI(folderData) {
  return await getResponse(
    `${getAPIEndPoint(URLS.FOLDERS_API)}/`,
    "post",
    folderData
  );
}

export async function deleteFolderAPI(folderId) {
  return await getResponse(
    `${getAPIEndPoint(URLS.FOLDERS_API)}/${folderId}/`,
    "delete",
  );
}

export async function getFolderStats(folderId, param) {
  const response = await getResponse(
    `${getAPIEndPoint(URLS.FOLDERS_API)}/${folderId}/stats`,
    "get",
    undefined,
    param
  );
  return response;
}

export async function getFolderStatsBySSOTFilter(folderId, param) {
  const response = await getResponse(
    `${getAPIEndPoint(URLS.FOLDERS_API)}/${folderId}/stats/query`,
    "post",
    param
  );
  return response;
}

export async function getFolderEvents(folderId, startDate, endDate, selectedCampaignTypes = []) {
  let aggregateBy = REPORT_INTERVALS.DAYS;
  if (startDate && endDate)
    aggregateBy = await determineBucketSize(startDate, endDate);

  const response = await getResponse(
    `${getAPIEndPoint(URLS.FOLDERS_API)}/${folderId}/events`,
    "get",
    undefined,
    {
      type: "view,click,sent",
      start_date: startDate,
      end_date: endDate,
      aggregate_by: aggregateBy,
      CampaignType: selectedCampaignTypes.length >= 3 ? "" : selectedCampaignTypes.join(",")
    }
  );
  response.aggregateBy = aggregateBy;
  return response;
}

export async function getFolderEventsBySSOTFilter(folderId, startDate, endDate, selectedCampaignTypes = [], filters = null) {
  let aggregateBy = REPORT_INTERVALS.DAYS;
  if (startDate && endDate)
    aggregateBy = await determineBucketSize(startDate, endDate);

  // CampaignType is always "advanced" — POST /events/query is exclusively for personalized
  // campaigns with SSOT filters active; the filter panel is gated behind "advanced" only mode
  const params = {
    type: "view,click,sent",
    start_date: startDate,
    end_date: endDate,
    aggregate_by: aggregateBy,
    CampaignType: "advanced",
  };

  if (filters) {
    params.filters = filters;
  }

  const response = await getResponse(
    `${getAPIEndPoint(URLS.FOLDERS_API)}/${folderId}/events/query`,
    "post",
    params
  );
  response.aggregateBy = aggregateBy;
  return response;
}